import { React, useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';

const Firework = ({ run }) => {
    const { width, height } = useWindowSize();
    const [pieces, setPieces] = useState(500);

    useEffect(() => {
        if (run) {
            setPieces(500); // Start confetti

            // Dispose confetti after 3 seconds
            const timer = setTimeout(() => {
                setPieces(0);
            }, 5000);

            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [run]);
    return (
        <Confetti
            width={width - 50}
            height={height}
            run={run}
            numberOfPieces={pieces}
            recycle={false}
        />
    );
};

export default Firework;